import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { Button } from '@/components/ui';

import styles from './index.module.scss';

const renderIncludes = (item, index) => {
  return item?.sections?.map((i) => {
    return (
      <div
        key={i?.text}
        className={styles.includingItem}
        itemScope
        itemType='https://schema.org/ImageObject'
      >
        <Image
          src={`/fiber${i?.icon}`}
          width={24}
          height={24}
          alt={i?.text}
          title={i?.text}
        />
        <span>{i?.text}</span>
      </div>
    );
  });
};

const FiberOfferItem = ({ offerItem }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const handleRoute = () => {
    router.push(`/fiber-check?tariff=${offerItem?.key}`);
  };

  return (
    <div
      key={offerItem?.key}
      className={styles.cardWrapper}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      <div className={styles.headingText}>{offerItem?.heading_text}</div>
      <div className={styles.speedContainer}>
        <p>{offerItem?.title}</p>
        <div className={styles.rectangle}></div>
      </div>
      <div className={styles.priceContainer}>
        <span>{offerItem?.price}</span>
        <span>₼/{t('esim:common.monthly')}</span>
      </div>
      <Button onClick={handleRoute}>{offerItem?.button_text}</Button>
      <div className={styles.includes}>
        <h3>{t('fiber:tariff.includes')}</h3>
        {renderIncludes(offerItem)}
      </div>
    </div>
  );
};

export default FiberOfferItem;
